import axiosInstance from './axios'
import { IActionCompanyRequest } from '../store/company/types'
import { AxiosResponse } from 'axios'

class CompaniesService {
    constructor(private apiVersion: string = 'v1') {
    }

    public async getCompany(filter: IActionCompanyRequest): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(filter)
            return axiosInstance.get(`${this.apiVersion}/companies`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getCompanyByDocument(document: string): Promise<any> {
        try {
            return axiosInstance.get(`${this.apiVersion}/companies/${document}`)
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    /**
     * Method to convert {@link IPaginator} object to {@link URLSearchParams}.
     * @param {IPaginator} [paginator] Paginator settings.
     * @param {IActionDocumentsRequest} [filters] Paginator settings
     * @return {URLSearchParams} Resulting object.
     */
    public buildParams(filters?: IActionCompanyRequest): URLSearchParams {
        const params = new URLSearchParams()

        if (filters) {

            if (filters?.cnpj) {
                params.append('cnpj', String(filters.cnpj))
            }
            if (filters?.razaoSocial) {
                params.append('name', String(filters.razaoSocial))
            }
            if (filters?.inscricaoEstadual) {
                params.append('state_registration', String(filters.inscricaoEstadual))
            }
            if (filters?.start_date) {
                params.append('start_date', String(filters.start_date))
            }
            if (filters?.end_date) {
                params.append('end_date', String(filters.end_date))
            }

        }
        return params
    }
}

const companyService = new CompaniesService()

export default companyService
